import type { PropsWithChildren, ReactNode } from "react";

import type { IPopoverOptions } from "@similarweb/ui-components";
import { Popover, PopoverTrigger } from "@similarweb/ui-components";

import { TOOLTIP_DELAY_TIMEOUT } from "./const";
import { type ContentTheme, StyledPopoverContent } from "./styles";

export type CellDefaultTooltipProps = {
    content: ReactNode;
    className?: string;
    theme?: ContentTheme;
    tooltipPlacement?: IPopoverOptions["placement"];
};

/* TODO move to pro-logic-components cells/atoms */
const CellDefaultTooltip = ({
    children,
    content,
    theme = "dark",
    className,
    tooltipPlacement = "top",
}: PropsWithChildren<CellDefaultTooltipProps>) => {
    return (
        <Popover
            placement={tooltipPlacement}
            delay={TOOLTIP_DELAY_TIMEOUT}
            withArrow
            isHover
        >
            <PopoverTrigger asChild>
                <span className={className}>{children}</span>
            </PopoverTrigger>

            <StyledPopoverContent $theme={theme}>{content}</StyledPopoverContent>
        </Popover>
    );
};

export default CellDefaultTooltip;
